import React, { useEffect, useMemo, useState } from "react";
import OnboardStep from "../OnboardStep";
import OnboardForgotPassword from "../OnboardForgotPassword/InitialScreen/index";
import OnboardNewAccount from "../OnboardNewAccount";
import ConfirmPinCode from "../OnboardForgotPassword/confirmPinCode";
import ChangePassword from "../ChangePassword";
import { setSessionStorageKey } from "../../utils";
import { Container, PageRecover } from "./styles";
import { useLocation } from "react-router-dom";
import history from "../../services/history";

export default function WelcomeHome(props) {
	const [paramsQuery] = useState(new URLSearchParams(useLocation().search));

	useEffect(() => {
		verifyIsEduca(window.location.href.includes("educa_recover"));
		let goBack = sessionStorage.getItem("GO_BACK");
		if (goBack === "REGISTER") localStorage.setItem("appflow", "REGISTER");

		// eslint-disable-next-line
	}, []);

	const [appflow, setAppFlow] = useState("REGISTER");

	useEffect(() => {
		if (window.location.pathname.includes("/welcome-register")) {
			setAppFlow("RECOVER");
			localStorage.setItem("appflow", "RECOVER");
		}
		const creatingBy = paramsQuery.get("CREATING_BY");

		if (creatingBy) {
			setSessionStorageKey("CREATING_BY", creatingBy);
		}
		// eslint-disable-next-line
	}, []);

	let flowPage = {
		param: undefined,
		token: undefined,
		cpf: undefined,
		recoveryInfoType: undefined,
		recoveryInfo: undefined,
	};

	if (props.location.state) {
		flowPage.param = props.location.state.param;
		flowPage.token = props.location.state.token;
		flowPage.cpf = props.location.state.cpf;
		flowPage.recoveryInfoType = props.location.state.recoveryInfoType;
		flowPage.recoveryInfo = props.location.state.recoveryInfo;
	}

	const showPages = useMemo(() => {
		if (flowPage.param === "confirm-pincode") {
			return <ConfirmPinCode sendInfos={flowPage} />;
		} else if (flowPage.param === "change-password") {
			return <ChangePassword sendInfos={flowPage} />;
		}

		if (appflow === "RECOVER") {
			return history.push("/onboard/recover-account");
		} else {
			return <OnboardNewAccount />;
		}
	}, [flowPage, appflow]);

	function verifyIsEduca(isEduca) {
		if (isEduca) {
			sessionStorage.setItem("educa", true);
			setAppFlow("RECOVER");
			showPages("RECOVER");
		}
	}

	return (
		<Container>
			<PageRecover>
				<OnboardStep />
				{showPages}
			</PageRecover>
		</Container>
	);
}
